import { SHIPPING_RATE_LOGS_ACTIONS, initialShippingRateLogsState } from './shippingRateLogs.types';
export function shippingRateLogsReducer(state = initialShippingRateLogsState, action) {
    switch (action.type) {
        case SHIPPING_RATE_LOGS_ACTIONS.SET_LOGS:
            return { ...state, data: action.payload };
        case SHIPPING_RATE_LOGS_ACTIONS.SET_LOG:
            return {
                ...state,
                data: {
                    ...state.data,
                    [action.payload.id]: action.payload
                }
            };
        case SHIPPING_RATE_LOGS_ACTIONS.SET_STATUS:
            return { ...state, status: action.payload };
        case SHIPPING_RATE_LOGS_ACTIONS.SET_ERRORS:
            return { ...state, errors: [action.payload, ...state.errors] };
        case SHIPPING_RATE_LOGS_ACTIONS.CLEAR_ERRORS:
            return { ...state, errors: [] };
        case SHIPPING_RATE_LOGS_ACTIONS.SET_META:
            return {
                ...state,
                pageCount: action.payload.pageCount,
                rowCount: action.payload.rowCount,
                currentPage: action.payload.currentPage,
                perPage: action.payload.perPage
            };
        default:
            return state;
    }
}
